import { client } from './client';
import type {
  ApiResponse,
  AnalyticsRange,
  StudentAnalyticsResponse,
  StudentHomeResponse,
  StudentMe,
  StudentSettingsUpdate,
  TodayPracticeCard,
} from '@/types/api';

export async function fetchHome(): Promise<StudentHomeResponse> {
  const { data } = await client.get<ApiResponse<StudentHomeResponse>>('/api/v1/miniapp/me/home');
  return data.data;
}

export async function fetchHistory(limit = 50): Promise<TodayPracticeCard[]> {
  const { data } = await client.get<ApiResponse<TodayPracticeCard[]>>(
    '/api/v1/miniapp/me/history',
    { params: { limit } },
  );
  return data.data ?? [];
}

export async function fetchAnalytics(range: AnalyticsRange): Promise<StudentAnalyticsResponse> {
  const { data } = await client.get<ApiResponse<StudentAnalyticsResponse>>(
    '/api/v1/miniapp/me/analytics',
    { params: { range } },
  );
  return data.data;
}

export async function updateSettings(patch: StudentSettingsUpdate): Promise<StudentMe> {
  const { data } = await client.put<ApiResponse<StudentMe>>(
    '/api/v1/miniapp/me/settings',
    patch,
  );
  return data.data;
}
